import { lockScroll, unlockScroll } from '@theme/utilities';

class SodMeganavDrawer extends HTMLElement {
  #controller;

  #opener = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.addEventListener(
      'click',
      (event) => {
        if ( (event.target).closest('[data-sod-meganav-close]')) this.close();
      },
      { signal }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
    unlockScroll(this);
  }

  open(opener) {
    if (this.hasAttribute('open')) return;
    this.#opener = opener ?? null;

    this.hidden = false;

    requestAnimationFrame(() => {
      this.setAttribute('open', '');
      this.querySelector('.sod-meganav__close')?.focus({ preventScroll: true });
    });

    lockScroll(this);
  }

  close() {
    if (!this.hasAttribute('open')) return;
    this.removeAttribute('open');
    unlockScroll(this);

    const done = () => {
      if (!this.hasAttribute('open')) this.hidden = true;
    };
    const panel = this.querySelector('.sod-meganav');
    if (panel) {
      panel.addEventListener('transitionend', done, { once: true });

      setTimeout(done, 400);
    } else {
      done();
    }

    if (this.#opener instanceof HTMLElement) this.#opener.focus({ preventScroll: true });
    this.#opener = null;
  }
}

if (!customElements.get('sod-meganav-drawer')) {
  customElements.define('sod-meganav-drawer', SodMeganavDrawer);
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest('[data-sod-meganav-opens]');
  if (!trigger) return;

  const drawer = document.getElementById(trigger.getAttribute('data-sod-meganav-opens') ?? '');
  if (!(drawer instanceof SodMeganavDrawer)) return;

  event.preventDefault();
  drawer.open(trigger);
});
